<header class="px-2 px-md-4">
  <div class="container-fluid">
    <div class="row">
      <div class="d-flex justify-content-between align-items-center header-inner">
        <a *ngIf="!isNoPromotion" href="#">
          <img src="../assets/images/logo.png" class="img-fluid logo" alt="Openionest">
        </a>

        <span *ngIf="isNoPromotion">
          <img src="../assets/images/logo.png" class="img-fluid logo" alt="Openionest">
        </span>
        <div class="text-end">
          <div id="google_translate_element"></div>
          <!-- <select class="form-select">
                      <option selected>Select Language</option>
                      <option value="1">English</option>
                      <option value="2">Germen</option>
                      <option value="3">French</option>
                    </select> -->
        </div>
      </div>
    </div>
  </div>
</header>
